import {getUserConfig} from "@utility/utils";

const initialState = {
    list: [],
    total: 0,
    loading: false,
    searchParams: {
        player_user_id: "",
        start_date: new Date(),
        end_date: new Date(),
        page: 1,
        count: 30,
        refresh: false,
        ...getUserConfig("playerSign")
    }
}

const sign = (state = initialState, action) => {
    switch (action.type) {
        case 'PLAYER_SIGN':
            return {
                ...state,
                ...action.payload
            }
        case 'PLAYER_SIGN_INIT':
            return {
                ...initialState,
                searchParams: {
                    ...initialState.searchParams, ...getUserConfig("playerSign")
                },
            }
        default:
            return {...state};
    }
}

export default sign
